import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all customerses
export const getCustomers = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/customers`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error.response?.data || error);
    throw error;
  }
};

// GET a single customers
export const getCustomersById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/customers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new customers
export const createCustomers = async (customersData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/customers`, customersData);
    return response.data;
  } catch (error) {
    console.error("Error creating customers:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing customers
export const updateCustomers = async (id, customersData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/customers/${id}`, customersData);
    return response.data;
  } catch (error) {
    console.error("Error updating customers:", error.response?.data || error);
    throw error;
  }
};

// DELETE a customers
export const deleteCustomers = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/customers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting customers:", error.response?.data || error);
    throw error;
  }
};
